<script setup lang="ts">
import { computed } from "vue";

import Btn from "@/components/ui/atoms/Btn.vue";
import PillContainer from "@/components/ui/atoms/PillContainer.vue";

const csrfToken = computed(
  () => document.querySelector("[name=csrfmiddlewaretoken]").value,
);
</script>

<template>
  <div class="social-login">
    <h3>O inicia sesión con...</h3>
    <PillContainer relaxed full-width>
      <form class="submit-form" method="POST" action="/accounts/google/login/">
        <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken" />
        <Btn
          type="submit"
          id="google-button"
          size="medium"
          theme="gray-bold"
          shape="round"
          class="social-button"
        >
          Google
        </Btn>
      </form>
      <form class="submit-form" method="POST" action="/accounts/github/login/">
        <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken" />
        <Btn
          type="submit"
          id="github-button"
          class="social-button"
          size="medium"
          theme="gray-bold"
          shape="round"
        >
          Github
        </Btn>
      </form>
      <form class="submit-form" method="POST" action="/accounts/linkedin/login/">
        <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken" />
        <Btn
          type="submit"
          id="linkedin-button"
          class="social-button"
          size="medium"
          theme="gray-bold"
          shape="round"
        >
          Linkedin
        </Btn>
      </form>
    </PillContainer>
  </div>
</template>

<style scoped lang="scss">
.social-login {
  margin: 32px 0 0 0;

  .social-button {
    background-repeat: no-repeat;
    background-size: auto 100%;
    padding-left: 35px;
    flex: 1;
  }

  #google-button {
    background-image: url("@img/icons/google-logo.svg");
  }

  #github-button {
    background-image: url("@img/icons/github-logo.svg");
  }

  #linkedin-button {
    background-image: url("@img/icons/linkedin-logo.svg");
  }

  .submit-form {
    flex: 1;
    display: flex;
  }

  .submit-form:nth-child(-n + 2) {
    margin-right: 4px;
  }
}
</style>
